import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";
import LHSectionHeader from "../../components/LHSectionHeader";
import FontFamily from "../../constants/fonts";
import { useTheme } from "../../theme";

const SparcWalkInspectionCompleteSection = () => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <>
      <View style={styles.container} testID="sparc-walk-complete-container">
      {/* Card with integrated header and body (matches other SPARC components) */}
      <View style={styles.cardContainer}>
        <LHSectionHeader
          title="Complete during and after the SPARC Walk"
          containerStyle={[
            styles.sectionHeader,
            isDark && { backgroundColor: colors.brand.primary },
          ]}
          textStyle={styles.header1text}
        />

        <View
          style={[
            styles.instructionContainer,
            isDark && {
              backgroundColor: colors.background.surface,
              borderColor: colors.border.default,
            },
          ]}
        >
          <View style={styles.instructionRow}>
            <Text style={[styles.bulletPoint, { color: colors.text.primary }]}>•</Text>
            <Text style={[styles.instructionLine, { color: colors.text.primary }]}> 
              Focus & continously improve
            </Text>
          </View>
          <View style={styles.instructionRow}>
            <Text style={[styles.bulletPoint, { color: colors.text.primary }]}>•</Text>
            <Text style={[styles.instructionLine, { color: colors.text.primary }]}>Empower & take ownership</Text>
          </View>
          <View style={styles.instructionRow}>
            <Text style={[styles.bulletPoint, { color: colors.text.primary }]}>•</Text>
            <Text style={[styles.instructionLine, { color: colors.text.primary }]}> 
              Go see firsthand & understand
            </Text>
          </View>
          <View style={[styles.instructionRow, styles.lastInstructionRow]}>
            <Text style={[styles.bulletPoint, { color: colors.text.primary }]}>•</Text>
            <Text style={[styles.instructionLine, { color: colors.text.primary }]}>Make it happen</Text>
          </View>
        </View>
      </View>
      </View>
    </>
  );
};
const styles = StyleSheet.create({
  container: {
    marginTop: 24,
  },
  cardContainer: {
    borderRadius: 6,
    // allow header to expand beyond original bounds when wrapping
    overflow: Platform.OS === "ios" ? "visible" : "hidden",
  },
  sectionHeader: {
    backgroundColor: "#3582E6",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    // use minHeight so header can expand to 2 lines when needed
    minHeight: 48,
  },
  header1text: {
    fontSize: 14,
    fontWeight: "700",
    lineHeight: 20,
    fontFamily: FontFamily.bold,
  },
  instructionContainer: {
    paddingTop: 12,
    paddingBottom: 10,
    borderColor: "#e9ecef",
    borderWidth: 1,
    borderTopWidth: 0,
    borderRadius: 6,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: "white",
    padding: 16,
  },
  instructionRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 6,
  },
  lastInstructionRow: {
    marginBottom: 0,
  },
  bulletPoint: {
    fontWeight: "bold",
    marginRight: 8,
    color: "#FFFFFF",
  },
  instructionLine: {
    flex: 1,
    color: "#FFFFFF",
    fontSize: 14,
    fontFamily: FontFamily.regular,
    fontWeight: "400",
    lineHeight: 20,
  },
});

export default SparcWalkInspectionCompleteSection;
